import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import AdminChatViewer from './pages/AdminChatViewer';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: 'white',
      },
    },
  },
});

function App() {
  return (
    <React.StrictMode>
      <ChakraProvider theme={theme}>
        <Router>
          <Routes>
            {/* Main admin dashboard */}
            <Route path="/" element={<Dashboard />} />

            {/* Chat viewer in new tab */}
            <Route path="/chat/:sessionId" element={<AdminChatViewer />} />

            {/* Redirect unknown routes to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ChakraProvider>
    </React.StrictMode>
  );
}

export default App;
